import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, ActivatedRoute, RouterLink } from '@angular/router';
import { UserPreferencesModalComponent } from './components/user-settings-modal/user-settings-modal.component';
import { InputRangeDirective } from './directives/input-range.directive';
import { environment } from './../environments/environment';
import { AuthService } from './services/auth.service';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { NgbCollapseModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HomeTourComponent } from './components/home-tour/home-tour.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet, RouterLink, CommonModule, UserPreferencesModalComponent,
    InputRangeDirective, NgbCollapseModule, NgbDropdownModule, HomeTourComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'tuningcalculator.web.client';
  isLoggedIn: boolean = false;
  isMenuCollapsed: boolean = true;
  firstName: string = '';
  lastName: string = '';

  private checkAuth = new Subject<void>();

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute, private modalService: NgbModal) {
    console.log(`Running in ${environment.name} mode.`);

    this.authService
      .loginEvent
      .subscribe(() => {
        this.isLoggedIn = true;
        this.firstName = this.authService.getFirstName();
        this.lastName = this.authService.getLastName();
        this.startCheckAuth();
      });

    this.authService
      .logoutEvent
      .subscribe(() => {
        this.isLoggedIn = false;
      });

    authService.isLoggedIn()
      .subscribe(isLoggedIn => {
        if (isLoggedIn) {
          console.log('user logged in');
          this.isLoggedIn = true;
          this.firstName = this.authService.getFirstName();
          this.lastName = this.authService.getLastName();
          this.startCheckAuth();
        }
      });
    
  }

  startCheckAuth() {
    this.authService.checkAuth()
      .pipe(takeUntil(this.checkAuth))
      .subscribe({
        error: error => this.stopCheckAuth(),
      });
  }

  stopCheckAuth() {
    this.checkAuth.next();
    this.checkAuth.complete();
  }

  logout() {
    this.stopCheckAuth();
    this.authService.logout();
  }

  openUserSettingsModal() {
    this.modalService.open(UserPreferencesModalComponent);
  }
}
